import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="text-xs text-zinc-500">404</div>
        <div className="text-lg mt-1 mb-3">{t('notFound.title')}</div>
        <Link to="/" className="btn-ghost text-xs">{t('notFound.back')}</Link>
      </div>
    </div>
  );
}
